import { render, staticRenderFns } from "./ContestBeneficiariesTable.vue?vue&type=template&id=8b0af1a4&scoped=true&"
import script from "./ContestBeneficiariesTable.vue?vue&type=script&lang=js&"
export * from "./ContestBeneficiariesTable.vue?vue&type=script&lang=js&"
import style0 from "./ContestBeneficiariesTable.vue?vue&type=style&index=0&id=8b0af1a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0af1a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardTitle,VDataTable,VIcon,VSpacer})
